import { React, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CancelIcon from "@mui/icons-material/Cancel";
import Image from "../../../images/smartPinModal.png";
import { InputAdornment, TextField } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import Pin from "../pin";
import { SHA256 } from "crypto-js";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: 525,
  minWidth: 303,
  bgcolor: "#FFFFFF",
  borderRadius: "24px",
  boxShadow: 24,
  p: "1rem 1.4rem ",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

export default function SmartPinModal(props) {
  const [pin, setPin] = useState("");

  const navigate = useNavigate();
  const calculateHash = (inputValue) => {
    const hashedValue = SHA256(inputValue).toString();
    return hashedValue;
  };
  const setSmartPin = (e) => {
    e.preventDefault();
    console.log(pin, calculateHash(pin));
    axios
      .post("https://api.blockpay.co.za/merchant/setSmartPin", {
        email: localStorage.getItem("email"),
        smartpin: calculateHash(pin),
      })
      .then((res) => {
        toast.success(res.data.message);
        console.log(res);
        navigate("/dashboard");
      })
      .catch((err) => {
        toast.error(err.response.data.message);
        console.log(err);
        if (err.response.data.message=="Unauthorized!"){
          localStorage.clear();
          navigate("/signinpin", {replace:true});
        }
      });
  };
  return (
    <div>
      <ToastContainer />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        {...props}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={props.open}>
          <Box sx={style}>
            <Box
              sx={{
                color: "#919191",
                marginLeft: "auto",
              }}
              onClick={props.onClose}
            >
              <CancelIcon />
            </Box>
            <Box
              component="img"
              src={Image}
              sx={{ height: "250px", width: "250px" }}
            />
            <Typography
              id="transition-modal-title"
              variant="h5"
              component="h2"
              sx={{ fontWeight: "500", lineHeight: "2.421rem" }}
            >
              Create Smart Pin
            </Typography>
            <Typography
              id="transition-modal-description"
              sx={{
                mt: 1,
                fontSize: "16px!important",
                color: "#626262",
                textAlign: "center",
              }}
            >
              Create Smart pin and access your dashboard and withdraw Rands
            </Typography>
            <Box
              sx={{
                textAlign: "left",
                mt: "1rem",
                mb: "1.5rem",
                width: "100%",
              }}
              className="otpInput"
            >
              <Pin otp={pin} setOtp={setPin} />
            </Box>

            <Button
              className="loginButtonSignUp"
              variant="contained"
              color="primary"
              size="large"
              type="submit"
              onClick={setSmartPin}
              sx={{
                textTransform: "none",
                borderRadius: "10px",
                marginTop: "2rem!important",
                mb: "1rem",
              }}
            >
              <span className="buttonSignText">Confirm</span>
            </Button>
            {/* <Box
              component={Link}
              to="/signinpass"
              sx={{ color: "#05b2ff", mb: "1rem" }}
            >
              Skip
            </Box> */}
          </Box>
        </Fade>
      </Modal>
    </div>
  );
}
